import React from 'react';
import PropTypes from 'prop-types';

const OccasionFilter = ({ selected, onChange, className = '' }) => {
  const occasions = [
    {
      id: 'daily',
      name: 'יומיומי',
      icon: '☀️',
      description: 'לכל יום',
      color: 'from-yellow-400 to-amber-500'
    },
    {
      id: 'work',
      name: 'עבודה',
      icon: '💼',
      description: 'מקצועי',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      id: 'evening',
      name: 'ערב',
      icon: '🌙',
      description: 'אירועים',
      color: 'from-purple-500 to-pink-600'
    },
    {
      id: 'sport',
      name: 'ספורט',
      icon: '⚽',
      description: 'פעילות',
      color: 'from-green-500 to-teal-600'
    },
    {
      id: 'special',
      name: 'מיוחד',
      icon: '✨',
      description: 'חגיגי',
      color: 'from-red-500 to-rose-600'
    }
  ];

  return (
    <div className={className}>
      <h3 className="text-sm lg:text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span className="text-xl">🎯</span>
        <span>לאיזה אירוע?</span>
      </h3>
      
      <div className="flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0 scrollbar-hide">
        {occasions.map((occasion) => (
          <button
            key={occasion.id}
            onClick={() => onChange(selected === occasion.id ? '' : occasion.id)}
            className={`flex-shrink-0 lg:flex-shrink flex items-center gap-3 p-3 rounded-lg border-2 transition-all duration-300 min-w-[140px] lg:min-w-0 lg:w-full ${
              selected === occasion.id
                ? 'bg-gradient-to-r ' + occasion.color + ' text-white border-transparent shadow-lg'
                : 'bg-white border-gray-200 hover:border-gray-300 hover:shadow-md'
            }`}
          >
            <div className="text-2xl">{occasion.icon}</div>
            <div className="text-right flex-1">
              <div className={`text-sm font-semibold ${selected === occasion.id ? 'text-white' : 'text-gray-900'}`}>
                {occasion.name}
              </div>
              <div className={`text-xs ${selected === occasion.id ? 'text-white/90' : 'text-gray-600'}`}>
                {occasion.description}
              </div>
            </div>
            {selected === occasion.id && (
              <div className="text-white">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

OccasionFilter.propTypes = {
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default OccasionFilter;

